module.exports = __webpack_public_path__ + "static/media/cyberpunk.f8a10d78.jpg";